export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7831.3d0a4e9d.jpg";